var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3026 13.2875C13.1158 13.4747 12.8621 13.58 12.5976 13.58C12.3331 13.58 12.0794 13.4747 11.8926 13.2875L7.0026 8.40748L2.1126 13.2975C1.92576 13.4847 1.67211 13.59 1.4076 13.59C1.14308 13.59 0.889427 13.4847 0.702595 13.2975C0.312595 12.9075 0.312595 12.2775 0.702595 11.8875L5.5926 6.99748L0.702595 2.10748C0.312595 1.71748 0.312595 1.08748 0.702595 0.697481C1.0926 0.307481 1.7226 0.307481 2.1126 0.697481L7.0026 5.58748L11.8926 0.697481C12.2826 0.307481 12.9126 0.307481 13.3026 0.697481C13.6926 1.08748 13.6926 1.71748 13.3026 2.10748L8.4126 6.99748L13.3026 11.8875C13.6826 12.2675 13.6826 12.9075 13.3026 13.2875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8c524c1391ae70049d30642399b523c1.svg";
export { ForwardRef as ReactComponent };